import { ViewChild } from '@angular/core';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { TranslationService } from '@sdbn/common';
import { DocumentTemplate } from '../../task.model';


export class SelectDocumentDialogComponentData {
  documents: Array<DocumentTemplate>;
  selected: DocumentTemplate;
}

@Component({
  selector: 'app-select-document-dialog',
  templateUrl: './select-document-dialog.component.html',
  styleUrls: ['./select-document-dialog.component.scss']
})
export class SelectDocumentDialogComponent implements OnInit {

  documents: Array<DocumentTemplate>;

  // Table parameters
  dataSource = new MatTableDataSource(new Array<DocumentTemplate>());
  selection = new SelectionModel<DocumentTemplate>();
  @ViewChild(MatSort) sort: MatSort;

  columnsToDisplay = ['name'];

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<SelectDocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectDocumentDialogComponentData) {

    this.dataSource.data = data.documents;

    if (data.selected != null) {
      this.toggleSelection(data.selected);
    }

  }

  ngOnInit() {
  }

  public toggleSelection(row: DocumentTemplate) {
    this.selection.toggle(row);
  }

  /**
   * Controls "no data" message in table if no rows are available
   */
  public showNoData(): boolean {
    return this.dataSource.filteredData.length === 0;
  }

  public selectDocument() {
    this.dialogRef.close(this.selection.selected[0]);
  }

  public isSelectDocumentDisabled(): boolean {
    return this.selection.selected.length === 0;
  }

  public cancel() {
    this.dialogRef.close(null);
  }

  public getRowStyles(transport: DocumentTemplate) {
    const styles: string[] = [];
    if (this.selection.isSelected(transport)) {
      styles.push('selected');
    } else {
      styles.push('deselected');
    }
    return styles;
  }

}
